import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'

const Heading = styled.h1`
  font-weight: bold;
  color: ${colours.darkPurple};
  font-size: 26px;
`

const HeadingControl = (props: PropsWithChildren<{}>) => <Heading>{props.children}</Heading>

export default HeadingControl
